import { makeAutoObservable } from "mobx";
import { Quantity, } from "../ordering";
import { PPrice } from "./PPrice";
import { ProductCardCreatorPrice } from "../pricing/ProductCardCreatorPrice";
import { PurchaseOrderPayloadTracking } from "../tracking";
export class PProductCardCreator {
    constructor(params) {
        this.domain = params.domain;
        this.productTypes = params.productTypes;
        this.localizationProvider = params.localizationProvider;
        this.productInstanceCreator = params.productInstanceCreator;
        this.crossSellingCreator = params.crossSellingCreator;
        makeAutoObservable(this);
    }
    get availability() {
        return this.domain.availability;
    }
    /** See {@link Creator.fixAvailability} */
    fixAvailability() {
        this.domain.fixAvailability();
    }
    get state() {
        return this.productInstanceCreator.state;
    }
    get price() {
        return new PPrice(this.localizationProvider, ProductCardCreatorPrice.price(this.domain).spectrum).priceValue;
    }
    get error() {
        return this.productInstanceCreator.error;
    }
    get quantity() {
        return this.domain.quantity.value;
    }
    get canDecrement() {
        return this.domain.quantity.gt(Quantity.One);
    }
    get canIncrement() {
        return true;
    }
    increment() {
        if (this.canIncrement) {
            this.domain.increment();
        }
    }
    decrement() {
        if (this.canDecrement) {
            this.domain.decrement();
        }
    }
    get product() {
        return this.productInstanceCreator.product;
    }
    get productTypeIdValues() {
        return this.domain.productTypeIds
            .rawValues()
            .map((productTypeId) => productTypeId.value);
    }
    get isSubmitVisible() {
        return !this.productInstanceCreator.state.isTemporaryUnavailable;
    }
    get isCancelVisible() {
        return this.productInstanceCreator.state.isTemporaryUnavailable;
    }
    finish() {
        this.productInstanceCreator.touch();
        PurchaseOrderPayloadTracking.collectCreatorData(this.domain);
        return this.domain.result;
    }
    get isSplitPossible() {
        return this.domain.isSplitPossible;
    }
    split() {
        this.domain.split();
        this.productInstanceCreator.updateState();
    }
    removeFirstHalf() {
        this.domain.removeFirstHalf();
        this.productInstanceCreator.updateState();
    }
    removeSecondHalf() {
        this.domain.removeSecondHalf();
        this.productInstanceCreator.updateState();
    }
    setFirstHalfProductType(productTypeString) {
        const productType = this.productTypes.rawGet(productTypeString);
        this.domain.setFirstHalfProductType(productType);
        this.productInstanceCreator.updateState();
    }
    setSecondHalfProductType(productTypeString) {
        const productType = this.productTypes.rawGet(productTypeString);
        this.domain.setSecondHalfProductType(productType);
        this.productInstanceCreator.updateState();
    }
    get temporairlyUnavailableIngredients() {
        return this.productInstanceCreator.state.temporairlyUnavailableIngredients;
    }
}
